export const PORTAL_ID_MODAL_BOTTOM = 'modal-bottom-div';
